/**
 * ============================================================
 * AdminDashboard.js — Central Admin Landing Page
 * ============================================================
 *
 * Shown immediately after login.
 * Provides links to all major admin sections.
 */

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SynlabAdminNavbar from "../components/SynlabAdminNavbar";
import SynlabAdminFooter from "../components/SynlabAdminFooter";

import { authFetch } from "../../utils/authFetch";
import "./css/AdminSubpage.css";

// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function AdminDashboard() {

  // ------------------------------------------------------------
  // Validate token on page load
  // ------------------------------------------------------------
  useEffect(() => {
    async function validateToken() {
      try {
        await authFetch("/api/authenticate"); 
        // If valid: nothing else happens
      } catch (err) {
        // If invalid: authFetch already redirects to /admin
        console.error("Token validation failed:", err);
      }
    }

    validateToken();
  }, []);

  // ------------------------------------------------------------
  // Logout function
  // ------------------------------------------------------------
  function handleLogout() {
    localStorage.removeItem("token");
    window.location.href = "/admin";  // force navigation to login page
  }

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------
  return (
    <div className="admin-wrapper">

      <SynlabAdminNavbar />

      <div className="admin-subpage-container">

        {/* ----- PAGE TITLE ----- */}
        <div className="admin-page-header">      
          <h1 className="admin-page-title">Admin Dashboard</h1>
        </div>

        {/* ----- PAGE DESCRIPTION ----- */}
        <p className="admin-page-description">Select an admin section:</p>

        {/* ----- ADMIN MENU ----- */}
        <div className="admin-dashboard-menu">
          <Link to="/admin/people" className="admin-dashboard-item">
            Manage People
          </Link>

          <Link to="/admin/projects" className="admin-dashboard-item">
            Manage Projects
          </Link>

          <Link to="/admin/publications" className="admin-dashboard-item">
            Manage Publications
          </Link>

          <Link to="/admin/users" className="admin-dashboard-item">
            Manage Admin Accounts
          </Link>
        </div>

        {/* ----- LOG OUT BUTTON ----- */}
        <div className="admin-logout-wrapper">
          <button className="btn btn-danger" onClick={handleLogout}>
            Log Out
          </button>
        </div>

      </div>

      {/* ----- FOOTER ----- */}
      <SynlabAdminFooter />

    </div>
  );
}

export default AdminDashboard;
